export const isValidDisplayUrl = (displayUrl: string): boolean => {
  return (
    !displayUrl.includes("/") && !displayUrl.toLowerCase().startsWith("http")
  );
};

export const isValidUrl = (url: string): boolean => {
  return /^(https?:\/\/)/.test(url);
};
